export default __webpack_public_path__ + "static/media/download_Icon.eb7e5b36.svg";